import { forwardRef } from 'react';

import { type AsChildProps } from '../../client/ClickableAnalyticsSlot';
import {
	BaseIconButton,
	type BaseIconButtonDefaultProps,
	type BaseIconButtonElementProps,
} from '../BaseIconButton/BaseIconButton';

const IconButtonSize = {
	sm: 16,
	md: 24,
} as const;

export type IconButtonDefaultProps = BaseIconButtonDefaultProps & {
	size?: keyof typeof IconButtonSize;
};

export type IconButtonElementProps = BaseIconButtonElementProps;

export type IconButtonProps = AsChildProps<IconButtonElementProps> & IconButtonDefaultProps;

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({ size = 'md', className, ...rest }, ref) => {
	const iconSize = IconButtonSize[size];

	return <BaseIconButton ref={ref} iconSize={iconSize} className={className} {...rest} padding="p-2 sm:p-3" />;
});
